var isSchema=function isSchema(obj){return obj&&obj.__isYupSchema__;};export default isSchema;